<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>
            <div class="flex items-center gap-2">
                <mat-icon>group</mat-icon>Shared billing
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="mt-4 flex flex-col gap-4">
            @if (ownerResource.value(); as owner) {
            <div class="flex items-center gap-4">
                <img class="h-10 w-10 rounded-full" [src]="owner.photoUrl?.value" alt="" />
                <p class="m-0">You are a shared billing member. Your usage is billed to <strong>{{owner.displayName}}</strong>'s account.</p>
            </div>
            } @else {
            <p class="m-0">You are a shared billing member. Your usage is billed to the shared billing owner's account.</p>
            }
            @if (isProTier()) {
            <p class="m-0">You also have a personal Pro subscription. This may no longer be needed while shared billing is active. You can review or cancel it using Manage Subscription below.</p>
            }
            @if (leaveError()) {
            <p class="m-0" role="alert">{{leaveError()}}</p>
            }
            @if (leaveState() === 'waiting') {
            <p class="m-0" role="status">You have left shared billing. Your account is updating. If this message remains, refresh the page.</p>
            }
        </div>
    </mat-card-content>
    <mat-card-actions align="end">
        <button matButton type="button" [disabled]="leaveState() !== 'idle'"
                [showProgress]="leaveState() === 'leaving'" (click)="leaveSharedBilling()">
            <mat-progress-spinner progressIndicator mode="indeterminate" [diameter]="20" aria-label="Leaving shared billing" />
            Leave shared billing
        </button>
    </mat-card-actions>
</mat-card>
